// Copyright (C) 2012 Minted Inc.
// All Rights Reserved
var module; UMD(module, {
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:m': ['M']
})(this, function(Backbone, m_module) {

var M = m_module.M;

/**
 * @class M.Collection.CyclerSlides
 *
 * Used by by the M.View.Cycler widget
 */
M.Collection.CyclerSlides = Backbone.Collection.extend({
  model: M.Model.CyclerSlide
});

return {};
});
